let CLAIM_TYPES = ['Insurance', 'InitClaim', 'ContClaim', 'ProcClaim']

export function getText(receivable) {
  return `${CLAIM_TYPES.includes(receivable.rtype) ? 'Claim' : 'Invoice'} #${receivable.human_readable_id}`
}
